(() => {
  const dialog = document.querySelector('[data-sealioo-newsletter]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'sealioo-newsletter-dismissed';
  let dismissed = false;
  let observer;
  let lastFocus;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) { /* Optional preference storage. */ }
  const otherDialogOpen = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]')).some(element => element !== dialog && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0);
  const open = (trigger) => {
    if (dialog.open || otherDialogOpen()) return false;
    lastFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
    dialog.showModal();
    observer?.disconnect();
    dialog.querySelector('[data-sealioo-newsletter-close]').focus();
    dialog.querySelector('[data-sealioo-newsletter-return]')?.focus();
    return true;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sealioo-newsletter-open]');
    if (button) open(button);
  });
  dialog.querySelector('[data-sealioo-newsletter-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    dismissed = true;
    observer?.disconnect();
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* The popup still closes when storage is unavailable. */ }
    if (lastFocus instanceof HTMLElement && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = Array.from(dialog.querySelectorAll('button, a[href], input, [tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length > 0);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  const waitForDialog = () => {
    observer = new MutationObserver(() => { if (!dismissed) open(); });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'style', 'class'] });
    window.setTimeout(() => observer?.disconnect(), 60000);
  };
  if (dialog.querySelector('[data-sealioo-newsletter-return]')) {
    if (!open()) waitForDialog();
  } else if (!dismissed && !dialog.hasAttribute('data-design-mode')) {
    window.setTimeout(() => {
      if (dismissed || open()) return;
      waitForDialog();
    }, 8000);
  }
})();

